import DOMPurify from "dompurify";

/*
 * Authored rich text is stored as HTML and has to be shown as HTML: education
 * overviews written by admins, and provider notes (which also embed a
 * patient's own intake answers). Rendering it raw lets a stored
 * <img onerror> or <script> run in every browser that opens it, with the
 * session cookie in reach.
 *
 * Anything headed for innerHTML or dangerouslySetInnerHTML goes through here
 * first. Formatting (paragraphs, headings, bold, lists, links) survives;
 * scripts, event handlers, javascript: URLs, iframes and forms do not.
 */

let hooked = false;
function ensureHooks() {
  if (hooked) return;
  hooked = true;
  // A link that opens a new tab must not hand that tab a handle back to Youro.
  DOMPurify.addHook("afterSanitizeAttributes", (node) => {
    if (node.tagName === "A" && node.getAttribute("target")) {
      node.setAttribute("rel", "noopener noreferrer");
    }
  });
}

export function sanitizeHtml(html) {
  if (!html) return "";
  ensureHooks();
  return DOMPurify.sanitize(String(html), {
    USE_PROFILES: { html: true },
    // Authored copy never needs to collect input or restyle the page. A form
    // inside a note or an education article would be a credential prompt
    // wearing Youro's own chrome, and a <style> block could cover the screen.
    FORBID_TAGS: ["form", "input", "button", "select", "textarea", "option", "style"],
    // Links may open a new tab; the hook above attaches rel to every one.
    ADD_ATTR: ["target"],
  });
}
